import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EliminarEntidadComponent } from '../../../helpers/components/deleteEntity/deleteEntity.component';
import { Product } from 'app/infrastructure/model/interfaces/product.interface';

@Component({
  selector: 'sx-home-product',
  templateUrl: './home.product.component.html',
  styleUrls: ['../../configuracion/subscription/nuevo.subscription.component.css']
})
export class HomeProductComponent implements OnInit, AfterViewChecked {
  @ViewChild(EliminarEntidadComponent) eliminarEntidad: EliminarEntidadComponent;

  @Input('product') product: Product;
  @Input('codSubscription') codSubscription: String;
  @Input('codChannel') codChannel: String;
  @Input('esNuevo') esNuevo: boolean;
  @Input('checkeandCodigo') checkeandCodigo: boolean;
  @Input('errorCodigo') errorCodigo: string;
  @Input('completitud') completitud: number;
  @Input('editable') editable: boolean;

  @Output('descripcionEditada') descripcionEditada: EventEmitter<string> = new EventEmitter();
  @Output('crearProducto') crearProducto: EventEmitter<string> = new EventEmitter();

  codProducto: String;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.codProducto = this.product.codProduct;
  }

  ngAfterViewChecked() {
    if (this.eliminarEntidad) {
      this.eliminarEntidad.eliminado.subscribe(x => this.volver());
    }
  }

  editarDescripcion(descripcion) {
    this.descripcionEditada.emit(descripcion);
  }

  confirmarNegocio() {
    this.crearProducto.emit();
  }
  volver() {
    this.router.navigate(['../../'], { relativeTo: this.route.parent });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/home/home.product.component.ts